import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { styled } from '@mui/material';
import MuiBox from '@mui/material/Box';
import CheckboxList from '../../../../Checkbox/CheckboxList.js';

const Root = styled(MuiBox) `
  width: 100%;
  position: relative;
  padding: ${({ theme }) => theme.spacing(1)};
`;
const FilterCheckboxListField = (_a) => {
    var { onSelectionChange, options, searchValue } = _a, rest = __rest(_a, ["onSelectionChange", "options", "searchValue"]);
    const value = useMemo(() => options.filter(({ name, label }) => !!name && !!label), [options]);
    const onIntervalChange = (values) => {
        onSelectionChange && onSelectionChange(values);
    };
    return (jsx(Root, Object.assign({}, rest, { children: jsx(CheckboxList, { searchValue: searchValue, options: value, onSelectionChange: onIntervalChange }) })));
};

export { FilterCheckboxListField as default };
//# sourceMappingURL=FilterCheckboxListField.js.map
